var bind = require('../function/virtual/bind');

var FunctionPrototype = Function.prototype;

module.exports = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (it instanceof Function && own === FunctionPrototype.bind) ? bind : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/bind.js
// module id = 984
// module chunks = 0